import styled from 'styled-components';
import { breakpoints } from './Variables';

export const NavStyles = styled.nav`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  color: var(--peach);
  height: var(--navHeight);
  z-index: 5;
  transition: all 0.5s;
  background-color: var(--green);

  h1 {
    color: var(--peach);
    line-height: calc(var(--navHeight) - 0.2rem);
    padding: 0 2rem;
    margin: 0;
    position: absolute;
    top: 0.2rem;
    left: 0;
    font-size: 1.5rem;
    width: 100%;
    border-bottom: 1px solid var(--peach);

    @media (min-width: ${breakpoints.breakLg}) {
      top: 0;
      padding-top: 9px; // Adjust for font not centered in block
      line-height: calc(var(--navHeight) - 10px); // Let bottom border fit
      font-size: 3rem;
      position: absolute;
    }
  }

  ul {
    margin: 2rem 0;
    font-size: 1.25em;
    list-style: none;
    display: none;
    padding: var(--navHeight) 2rem;

    &:not(.subNav) {
      min-height: calc(100vh - var(--navHeight) * 2 - 2rem);
    }

    li {
      display: block;
      color: var(--peach);
      padding-bottom: 1rem;
      position: relative;
      /* white-space: nowrap; */

      .placeholder,
      a,
      button {
        display: block;
        color: var(--peach);
        text-transform: uppercase;
        text-decoration: none;
        letter-spacing: 1px;
        // Resets for buttons
        font-family: Baskerville, serif;
        outline: none;
        border: none;
        border-radius: 0;
        padding-bottom: 0;
        padding-left: 0;
        padding-right: 0;
      }

      .subNav {
        height: 0;
        overflow: hidden;
        opacity: 0;
        transition: opacity 1s;

        .title,
        .placeholder {
          display: none;
        }

        .title {
          text-transform: uppercase;
          font-family: Avenir, sans-serif;
        }

        .navBackground {
          display: none;
        }
      }

      &.expanded {
        .subNav {
          height: auto;
          opacity: 1;
        }
      }
    }

    .toggleSubNavExpanded {
      position: absolute;
      right: 0;
      top: 0;

      @media (min-width: ${breakpoints.breakLg}) {
        display: none;
      }
    }
  }

  .subNav {
    margin: 0;
    padding: 0.25rem 0 0 0;

    li {
      font-size: 1rem;
      padding-bottom: 0;

      .placeholder,
      a,
      button {
        padding: 0.5em 0 0.25em 0;
        opacity: 0.85;
        text-transform: none;
        font-style: italic;
      }
    }

    &.withImages {
      // Don't display these on mobile (see media query below)
      img {
        display: none;
      }
    }
  }

  .extras {
    display: none;
    padding: 1rem var(--col1);
    justify-content: space-between;

    button,
    a {
      color: var(--peach);
      font-family: Avenir, sans-serif;
    }

    button {
      padding: 0;
    }
  }

  .toggleExpanded {
    width: 2rem;
    height: var(--navHeight);
    position: absolute;
    right: 2rem;
    top: 0;
    cursor: pointer;

    &.close {
      display: none;
    }

    @media (min-width: ${breakpoints.breakLg}) {
      display: none !important;
    }
  }

  &.expanded {
    height: 100vh;
    z-index: 10;

    ul {
      display: block;
    }

    .extras {
      display: flex;
    }

    .toggleExpanded.open {
      display: none;
    }
    .toggleExpanded.close {
      display: inline-block;
    }

    @media (max-width: ${breakpoints.breakLg}) {
      overflow-y: auto;
    }
  }

  // Change background colours
  &.customPage,
  &.propertyPage {
    background-color: var(--offWhite);
  }
  &.journalPage {
    background-color: var(--peach);
  }

  // Change text colours for property & journal pages
  &.journalPage,
  &.customPage,
  &.propertyPage {
    h1 {
      border-bottom-color: var(--black);
    }

    h1,
    .toggleExpanded,
    .title,
    ul li a,
    ul li button {
      color: var(--black);
    }

    .toggleSubNavExpanded {
      color: var(--black);
    }

    .extras {
      a,
      button {
        color: var(--green);
      }
    }
  }

  // this is for main parent style (<nav>)
  @media (max-width: ${breakpoints.breakLg}) {
    .subNav.expandChildren {
      .title {
        display: block;
        /* color: var(--black); */
        margin-top: 1rem;
      }

      .hasChildren:not(.expanded) {
        .linkWrapper {
          display: none;
        }
      }
    }
  }

  // this is for main parent style (<nav>)
  @media (min-width: ${breakpoints.breakLg}) {
    height: auto;
    min-height: var(--navHeight);

    ul {
      display: block;
      margin: 0;
      padding: 0 0 0 calc(var(--col1) + 7rem);
      display: flex;

      &:not(.subNav) {
        min-height: unset;
        display: flex;
        justify-content: flex-end;
        /* font-size: var(--fsButton); */ // Do this when we add another button
      }

      li {
        position: unset;
        z-index: 1;
        display: inline-block;
        width: auto;
        height: 100%;
        padding-bottom: 0;
        margin-right: 2rem;

        a,
        button {
          line-height: calc(var(--navHeight) - 6px);
          padding-top: 3px;
          transition: all 0.5s;
          border-bottom: 2px solid transparent;

          &:hover,
          &.current,
          &[aria-current] {
            border-bottom-color: var(--peach);
            font-weight: bold;
          }
        }

        // Sub navigation expand on hover
        &.hasChildren:not(.noShadow) {
          &:hover {
            height: 24rem;
            border-bottom: 1px solid transparent; //bugfix

            // Drop shadow below expanded menu
            &::after {
              display: block;
              content: '';
              position: absolute;
              left: 0;
              width: 100%;
              height: 2rem;
              z-index: 1;
              top: 24rem;
              background: linear-gradient(
                to top,
                transparent,
                rgba(0, 0, 0, 0.25) 100%
              );
            }

            .subNav {
              display: flex;
              opacity: 1;
              overflow: visible;
              height: calc(100% - 9rem); // 9rem = approx height of main
              width: calc(100% - 4rem); // 4rem = side padding

              li {
                height: auto;
                width: calc((100% - 400px) / 4);

                a,
                button,
                .placeholder {
                  display: inline-block;
                }

                .linkWrapper {
                  display: block;
                }
              }

              .navBackground {
                display: inline-block;
              }

              // Images within each subnav item
              &.withImages {
                display: grid;
                grid-template-columns: repeat(3, 350px);
                grid-gap: 2rem;
                justify-content: center;

                li {
                  display: block;
                  width: 100%;
                  height: 100%;
                }

                a {
                  padding: 0;
                  border: none;

                  img {
                    margin-bottom: 1rem;
                    display: block;
                  }

                  // Normally border should go on whole link element,
                  // but in this case causes border along whole image width
                  &:hover,
                  &[aria-current] {
                    opacity: 1;

                    span {
                      border-bottom: 1px solid var(--peach);
                    }
                  }
                }
              }
            }
          }
        }

        .toggleSubNavExpanded {
          display: none;
        }

        // Sub navigation before
        .subNav {
          position: absolute;
          top: calc(var(--navHeight) + 1rem);
          left: 2rem;

          .navBackground {
            position: absolute;
            right: 0;
            top: 1rem;
            width: auto;
            height: 100%;
          }

          .placeholder {
            display: block;
          }

          .title {
            display: block;
            margin-bottom: 1rem;
          }

          li {
            display: block;
            margin: 0;
            padding: 0.75rem 0;

            a {
              line-height: 1em;
              font-weight: bold;
            }
          }
        }
      }
    }

    // Resets for if we go from small, expanded to desktop (which ignores expanded)
    &.expanded {
      height: auto;

      .subNav {
        display: none;
      }

      .extras {
        display: none;
      }
    }

    // Change colours for property and journal pages
    &.journalPage,
    &.customPage,
    &.propertyPage {
      ul:not(.subNav) {
        border-bottom: 1px solid var(--black);
      }

      .subNav {
        .placeholder,
        .title {
          color: var(--black);
        }

        .placeholder {
          opacity: 0.6;
        }

        &.withImages {
          li a {
            &:hover,
            &[aria-current] {
              span {
                border-color: var(--black) !important;
              }
            }
          }
        }
      }

      a,
      button {
        &:hover,
        &.current,
        &[aria-current] {
          border-bottom-color: var(--black);
        }
      }
    }
  }
`;
